import React from "react";
export default function ParseDescripcion({
  descripcion,
}: Pick<IProducto, "descripcion">) {
  if (!descripcion) {
    return <p>---</p>;
  }
  const array = descripcion.split("-");
  return (
    <>
      {array.map((i, ind) => (
        <p key={ind}>{i}</p>
      ))}
    </>
  );
}
